(function ($) {
    jQuery(document).ready(() => {

        let slide = 8;

        $(".yacht-slider").owlCarousel({
            items: 1,
            loop: false,
            dots: true,
            nav: false,
            autoHeight:true,
            onInitialize: () => {
                let child = $(".yacht-slider").children();

                $('.yacht-slider__thumbs').html(child.clone());
                $('.yacht-slider__thumbs .bg_img').addClass('item');

            }
        });

        setTimeout(() => {
            $('.yacht-slider__thumbs').owlCarousel({
                items: slide,
                margin: 10,
                nav: true,
                dots: true,
                mouseDrag: false,
                touchDrag: false,
                navText: ['<i class="fa bg-chevron"></i>','<i class="fa bg-chevron"></i>']
            });

            $('.yacht-slider__thumbs .item').first().addClass('active');
        }, 100);

        $(".yacht-slider").on('translated.owl.carousel', function (event) {
            $('.yacht-slider__thumbs .item').removeClass("active");
            var c = $(".yacht-slider .owl-item.active").index();
            $('.yacht-slider__thumbs .item').eq(c).addClass("active");
            var d = Math.ceil((c + 1) / (slide)) - 1;
            $(".yacht-slider__thumbs .owl-dots .owl-dot").eq(d).trigger('click');
        })

        $('.yacht-slider__thumbs').on('click', '.item',  function () {

            var b = $(".item").index(this);
            $(".yacht-slider .owl-dots .owl-dot").eq(b).trigger('click');
            $(".yacht-slider__thumbs .item").removeClass("active");
            $(this).addClass("active");
        });
    });

})(jQuery);

